/**
 * Router `location.state` when opening Planning roadmaps from Prioritization (Strategy nav).
 * Propagated list → editor → print so print "back" can return to Prioritization instead of Planning chrome.
 */

export type RoadmapPlanningNavState = {
  roadmapEnteredFromPrioritization: true;
  roadmapReturnToPrioritization: string;
};

export const ROADMAP_FROM_PRIORITIZATION_STATE: RoadmapPlanningNavState = {
  roadmapEnteredFromPrioritization: true,
  roadmapReturnToPrioritization: '/prioritization/strategy',
};

/** Avoid treating attacker-controlled strings as internal routes (path traversal / protocol-relative). */
function isSafePrioritizationReturnPath(p: string): boolean {
  if (!p.startsWith('/prioritization')) return false;
  if (p.includes('..') || p.includes('//')) return false;
  return p === '/prioritization' || p.startsWith('/prioritization/');
}

export function isRoadmapPlanningNavState(s: unknown): s is RoadmapPlanningNavState {
  if (!s || typeof s !== 'object') return false;
  const o = s as Record<string, unknown>;
  return (
    o.roadmapEnteredFromPrioritization === true &&
    typeof o.roadmapReturnToPrioritization === 'string' &&
    isSafePrioritizationReturnPath(o.roadmapReturnToPrioritization)
  );
}
